import HttpRequest from './http_request'

class departProvider extends HttpRequest{
    initData(path){
        return this.fetch(path)
    }
}

export default departProvider